import { Contact, ContactV2, ContactMemberV2, Label, LabelList, LabelStaff, Person, searchContact, StaffLabel } from 'type/contact';
import Request from './request';
import { AdressBoookConfig, DefaultSuccess } from 'type/http';

const request = new Request('meeting');
type contactType = 1 | 2;
/**
 * 获取联系人
 * @param type 1-常用联系人 2-外部联系人
 */
export const getContacts = (type: contactType = 1) => {
  return request.get<Contact[]>(`/api/personal_contacts?type=${type}`);
};

/**
 * 获取常用联系人列表-V2
 */
export const getContactsV2 = () => {
  return request.get<DefaultSuccess<ContactMemberV2[]>>('/api/user/contact-person/actions/recommend');
};

/**
 * 获取标签列表
 */
export const getLabelList = () => {
  return request.get<{ data: LabelList[] }>('/api/user/label/list');
};

/**
 * 获取标签员工列表
 * @param labelId 标签id
 */
export const getLabelStaff = (labelId: number) => {
  return request.get<{ data: LabelStaff[] }>(`/api/user/label/getLabelStaff?labelId=${labelId}`);
};

/**
 * 根据staffId获取用户信息
 * @param staffIds
 */
export const getByStaffIds = (staffIds: string) => {
  return request.get<{ data: Person[] }>(`/api/user/staff/getByStaffIds?staffIds=${staffIds}`);
};

/**
 * 获取常用联系人列表
 */
export const getRecommends = () => {
  return request.get<Person[]>('/api/user/meetings/meeting_members/actions/recommend');
};

/**
 * 搜索联系人
 * @param keyword 关键字
 * @param searchId 搜索id
 */
export const searchContacts = (keyword: string, searchId?: string) => {
  return request.get<searchContact>(`/api/personal_contacts/action/query-list?keyword=${keyword}${searchId ? `&searchId=${searchId}` : ''}`);
};

/**
 * 搜索联系人-v2
 * @param keyword 关键字
 */
export const searchContactsV2 = (keyword: string) => {
  return request.get<DefaultSuccess<{ data: ContactMemberV2[] }>>(`/api/personal_contacts/v2/actions/search?keyword=${keyword}`);
};

/**
 * 修改联系人信息
 * @param remark 备注
 * @param staffId
 */
export const editContact = (remark: string, staffId: string) => {
  return request.put<DefaultSuccess>(`/api/personal_contacts/${staffId}`, {
    remark
  });
};

/**
 * 删除联系人
 * @param staffId
 */
export const deleteContact = (staffId: string) => {
  return request.delete<DefaultSuccess>(`/api/personal_contacts/${staffId}`);
};

/**
 * 添加联系人
 * @param id
 * @param staffId
 */
export const addContact = (id: string, staffId: string) => {
  return request.post<DefaultSuccess>('/api/personal_contacts', {
    id,
    staffId
  });
};

/**
 * 根据staffId获取用户信息
 * @param staffIds
 */
export const getDetailByStaffIds = (staffIds: string) => {
  return request.post<{ data: Contact[] }>('/api/user/staff/contactPersonDetail', {
    personStaffIdList: staffIds.split(',')
  });
};

/**
 * 更新标签名称
 * @param labelId
 * @param name
 * @returns
 */
export const updateLabelName = (labelId: number, name: string) => {
  return request.post<DefaultSuccess>('/api/user/label/update', {
    id: labelId,
    name
  });
};

/**
 * 新建标签
 * @param name
 * @returns
 */
export const createLabel = (name: string) => {
  return request.post<{ data: Label }>('/api/user/label/create', {
    name
  });
};

/**
 * 设置标签员工
 * @param labelId
 * @param staffId
 * @returns
 */
export const setLabelStaff = (labelId: number, staffIds: string[]) => {
  return request.post<DefaultSuccess>('/api/user/label/setLabelStaff', {
    labelId,
    staffIds
  });
};

/**
 * 删除标签
 * @param id
 * @returns
 */
export const deleteLabel = (id: number) => {
  return request.post<DefaultSuccess>('/api/user/label/delete', {
    id
  });
};

/**
 * 获取员工标签
 * @param staffId
 */
export const getStaffLabelList = (staffId: string) => {
  return request.get<{ data: StaffLabel[] }>(`/api/user/label/getStaffLabelList?staffId=${staffId}`);
};

// 获取阿波罗通讯录配置
export const getAdressBoookConfig = (companyId: string | undefined, appId: string = 'com.maxhub.meetingclient') => {
  return new Promise((resolve, reject) => {
    request.get<AdressBoookConfig>(`/api/client/app-configurations?companyId=${companyId}&appId=${appId}`)
      .subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

/**
 * 获取组织架构
 */
export const getOrgContacts = () => {
  return request.get<{ data: ContactV2[] }>('/api/personal_contacts/org-structure/list');
};
